import featureFlags from '@masfront/common-feature-flags'
import axios from 'axios'

import Permission from '../model/permissions.model'

import { getToken } from '~/net'

export interface FetchPermissionsProps {
  brand: string
  sub: string
}

export interface Permissions {
  total: number
  items: Permission[]
}

export class PermissionsService {
  constructor(private apiGateway: string) {}

  fetchPermissions(fetchPermissionsProps: FetchPermissionsProps): Promise<Permissions> {
    const { sub } = fetchPermissionsProps
    const flags = featureFlags.getFlags()

    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token?.access_token}` }
        }
        return axios.get<Permissions>(`${this.apiGateway}/toolkit/v1/authz/permissions`, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'cache-control': 'no-cache',
            'x-sfid': sub,

            ...authHeaders,
          },
        })
      })
      .then((resp) => resp.data)
  }
}
